import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { posts } from '@/mocks/posts';
import { siteInfo } from '@/mocks/site';

export default function HeroSection() {
  return (
    <section className="w-full bg-background-100 border-b border-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-[1.05fr_0.95fr] gap-10 lg:gap-14 items-center">
          <div className="rise-in">
            <span className="inline-flex items-center gap-2 rounded-full bg-background-50 border border-background-300 px-3.5 py-1.5 text-xs text-foreground-700">
              <i className="ri-flashlight-line text-primary-500"></i>
              今日已更新 {posts.length} 篇话题整理
            </span>

            <h1 className="mt-5 font-heading text-3xl md:text-4xl lg:text-[44px] font-bold leading-[1.25] text-foreground-950">
              {siteInfo.name}
              <span className="block mt-2 text-2xl md:text-3xl lg:text-4xl text-primary-700">
                把热闹话题整理成看得懂的合集
              </span>
            </h1>

            <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-600 max-w-xl">
              汇集娱乐圈、网红圈、素人瓜与行业秘闻，按分类合集整理、支持分区浏览。
              快速找到你感兴趣的爆料类型，一站式吃瓜看料——不标题党，也不越界。
            </p>

            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <Link
                to="/#categories"
                className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-layout-grid-line"></i>
                进入分类合集
              </Link>
              <Link
                to="/#trending"
                className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md border border-foreground-300 text-foreground-900 text-sm font-medium hover:border-primary-400 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                看看今天的热门
              </Link>
            </div>

            <div className="mt-9 flex flex-wrap items-center gap-x-8 gap-y-4">
              <div>
                <div className="font-heading text-2xl font-bold text-foreground-950">
                  {categories.length}
                </div>
                <div className="mt-1 text-xs text-foreground-500 tracking-wide">内容分区</div>
              </div>
              <div className="w-px h-9 bg-background-300 hidden sm:block"></div>
              <div>
                <div className="font-heading text-2xl font-bold text-foreground-950">
                  {posts.length}+
                </div>
                <div className="mt-1 text-xs text-foreground-500 tracking-wide">话题整理</div>
              </div>
              <div className="w-px h-9 bg-background-300 hidden sm:block"></div>
              <div>
                <div className="font-heading text-2xl font-bold text-foreground-950">
                  {siteInfo.since}
                </div>
                <div className="mt-1 text-xs text-foreground-500 tracking-wide">开始整理</div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="w-full h-64 md:h-80 lg:h-[420px] rounded-lg overflow-hidden border border-background-300 bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20hero%20illustration%20of%20a%20vast%20melon%20field%20under%20warm%20sunset%20sky%20with%20rolling%20hills%20drawn%20as%20soft%20geometric%20shapes%2C%20warm%20vermillion%20gold%20and%20sage%20palette%20on%20cream%20paper%20texture%2C%20stylized%20artistic%20poster%2C%20no%20people%2C%20high%20detail&width=1200&height=1000&seq=gt-hero-01&orientation=portrait"
                alt="夕阳下的瓜田与起伏山丘插画，象征话题合集的分区整理"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="hidden md:block absolute -bottom-5 -left-5 rounded-lg border border-background-300 bg-background-50 px-5 py-4">
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 rounded-md bg-accent-500 flex items-center justify-center">
                  <i className="ri-bookmark-3-line text-foreground-950 text-lg"></i>
                </span>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">按主题分类</div>
                  <div className="text-xs text-foreground-500 mt-0.5">不再被信息流牵着走</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}